export default "__VITE_ASSET__gXTiZES7__"